import { useCallback } from "react";

export const useYupValidationResolver = validationSchema =>
  useCallback(
    async data => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false
        });

        return {
          values,
          errors: {}
        };
      } catch (errors) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors, currentError) => {
                let errorCode = currentError.message.split('[')[1];
                if(errorCode){
                    errorCode = errorCode.split("]")[0];
                }else{
                    errorCode = null;
                }
                return ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
                errorCode: errorCode
              }
            })},
            {}
          )
        };
      }
    },
    [validationSchema]
  );